// src/app/shared/single-data-picker/single-data-picker.component.ts
import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
} from "@angular/core";
import {
  BsLocaleService,
  BsDatepickerConfig,
  BsDatepickerDirective,
} from "ngx-bootstrap/datepicker";
import { ptBrLocale } from "ngx-bootstrap/locale";
import { defineLocale } from "ngx-bootstrap/chronos";
defineLocale("pt-br", ptBrLocale);
@Component({
  selector: "app-single-data-picker",
  templateUrl: "./single-data-picker.component.html",
  styleUrls: ["./single-data-picker.component.scss"],
})
export class SingleDataPickerComponent implements OnInit {
  @Input() date: Date = new Date(); // Input to receive initial date
  @Output() dateChange = new EventEmitter<Date>(); // Output to emit date changes
  @ViewChild("dateInput", { static: false }) datepicker!: BsDatepickerDirective; // Reference to the datepicker
  bsConfig: Partial<BsDatepickerConfig>; // Datepicker configuration

  constructor(private localeService: BsLocaleService) {
    this.localeService.use("pt-br"); // Set the locale to Brazilian Portuguese
  }

  ngOnInit(): void {
    this.bsConfig = {
      dateInputFormat: "DD/MM/YYYY", // Brazilian date format
      containerClass: "theme-default",
    };
  }

  onDateSelect(newDate: Date): void {
    this.dateChange.emit(newDate); // Emit the new date to the parent component
  }
  openCalendar(): void {
    this.datepicker.show(); // Open the calendar popup programmatically
  }
}
